import { useMatch, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { CirclePlus, RefreshCw } from "lucide-react";
import { Button, Menu, Tooltip, type MenuItem } from "@marekl/adminer/components";
import { atLeast, useCompany } from "../../lib/queries/companies";
import styles from "./QuickAdd.module.css";

/**
 * The legacy header's right side: "nová položka ⊕" (a new document, contact
 * or product in the current company) and the refresh of everything shown.
 */
export function QuickAdd() {
  const match = useMatch("/c/:companyId/*");
  const navigate = useNavigate();
  const qc = useQueryClient();
  const c = match?.params.companyId;
  // Creating is an editor's; a viewer gets only the refresh.
  const role = useCompany(c).data?.role;
  const editor = atLeast(role, "editor");
  const doc = (type: string) => () => navigate(`/c/${c}/documents/new?type=${type}`);
  const items: MenuItem[] = c && editor
    ? [
        { id: "inv", label: "Vydaná faktura", onSelect: doc("sales_invoice") },
        { id: "quote", label: "Cenová nabídka", onSelect: doc("sales_order") },
        { id: "retail", label: "Prodejka", onSelect: doc("retail") },
        { id: "purchase", label: "Přijatá faktura", onSelect: doc("purchase_invoice") },
        { type: "separator" },
        { id: "contact", label: "Kontakt", onSelect: () => navigate(`/c/${c}/contacts/new`) },
        { id: "product", label: "Produkt", onSelect: () => navigate(`/c/${c}/products/new`) },
      ]
    : [];

  return (
    <>
      {items.length > 0 && (
        <Menu
          align="end"
          aria-label="Nová položka"
          trigger={
            <span className={styles.trigger}>
              nová položka <CirclePlus size={20} className={styles.plus} aria-hidden="true" />
            </span>
          }
          items={items}
        />
      )}
      <span className={styles.refresh}>
        <Tooltip content="Načíst znovu">
          <Button iconOnly weight="ghost" aria-label="Načíst znovu" startIcon={<RefreshCw size={18} />} onClick={() => void qc.refetchQueries({ type: "active" })} />
        </Tooltip>
      </span>
    </>
  );
}
